export const pageData ={
    dataPerPage : 100,
    apiHit :7
}